import React, { ChangeEvent, RefObject } from "react";
import { UseFormRegister, FieldError } from "react-hook-form";
import ErrorsMessage from "app/components/common/errors/ErrorsMessage";
import UploadIcon from "app/assets/icons/UploadIcon";
import DeleteIcon from "app/assets/icons/DeleteIcon";
import pdf_icon from "app/assets/icons/pdf_icon.svg";

interface DocumentUploadFieldProps {
  label: string;
  previewUrl: string | null;
  fieldName: string;
  savedFileUrl?: string;
  register: UseFormRegister<any>;
  error?: FieldError;
  fileInputRef: RefObject<HTMLInputElement>;
  onFileChange: (e: ChangeEvent<HTMLInputElement>, type: string) => void;
  onChooseFile: () => void;
  onDelete: () => void;
  imageObject?: File | null;
}
const DriverLicenseUpload: React.FC<DocumentUploadFieldProps> = ({
  label,
  previewUrl,
  fieldName,
  savedFileUrl,
  register,
  error,
  fileInputRef,
  onFileChange,
  onChooseFile,
  onDelete,
  imageObject,
}) => {
  return (
    <div className="w-full md:w-full xl:w-[49%]">
      {previewUrl || savedFileUrl ? (
        <div className="bg-[#EAECF0] p-5 text-center rounded-[20px] relative h-[250px] flex justify-center items-center w-full mb-4">
          {imageObject && imageObject.type === "application/pdf" ? (
            <div className="text-center w-[80%] overflow-hidden mx-auto">
              <img
                src={pdf_icon}
                alt="pdf_icon "
                className="rounded-[20px] text-center m-auto"
              />
              <p className="font-Mulish text-[#000] font-normal text-base ">
                {imageObject.name}
              </p>
            </div>
          ) : (
            <img
              src={previewUrl || savedFileUrl!}
              alt="Uploaded Preview"
              className="mx-auto  h-[200px]  rounded-[20px]"
              onError={(e) => (e.currentTarget.src = pdf_icon)}
            />
          )}
          <DeleteIcon
            onClick={onDelete}
            className="absolute cursor-pointer top-[10px] right-[10px]"
          />
        </div>
      ) : (
        <div className="bg-[#EAECF0] py-5 w-full relative text-center rounded-[20px] h-[250px]">
          <div className="text-center mb-4">
            <UploadIcon />
          </div>
          <h6 className="text-[14px] font-normal text-darkgrey mb-3">
            {label}
          </h6>
          <p className="text-[12px] font-normal text-[#98A2B3] w-full sm:w-[80%] mx-auto mb-5">
            Upload the front side of the document supports: JPG, PNG, PDF
          </p>
          <div className="m-auto">
            <input
              type="file"
              accept="image/jpeg, image/png, application/pdf"
              {...register(fieldName, {
                required: !savedFileUrl ? "Image is required" : false,
                validate: {
                  fileSize: (value: File) =>
                    value && value.size > 5 * 1024 * 1024
                      ? "File size should not exceed 5MB"
                      : true,
                  fileType: (value: File) =>
                    value &&
                    !["image/jpeg", "image/png", "application/pdf"].includes(
                      value.type
                    )
                      ? "Invalid file type. Only JPG, PNG are allowed"
                      : true,
                },
              })}
              onChange={(e) => onFileChange(e, fieldName)}
              ref={fileInputRef}
              hidden
            />
            <button
              type="button"
              onClick={onChooseFile}
              className="border border-solid border-[#ccc] text-sm font-normal text-[#585C7B] rounded-full px-4 py-2"
            >
              Choose file
            </button>
          </div>
          {error && (
            <ErrorsMessage
              title={
                error.message
                  ?.replace(/[^\w\s]/gi, "") // Remove special characters
                  .toLowerCase()
                  .replace(/^\w/, (c) => c.toUpperCase()) ?? // Capitalize only first letter
                ""
              }
              className="absolute top-[100%] left-0"
            />
          )}
        </div>
      )}
    </div>
  );
};

export default DriverLicenseUpload;
